import { IonText } from '@ionic/react'
import { getErrorMessage } from 'mobile_web/modules/platform'
import React from 'react'

interface Props {
	error: Error
}

const ErrorMessageHandler: React.FC<Props> = props => {
	if (!props.error) {
		return null
	}

	return <IonText className="error-occurred">{getErrorMessage(props.error)}</IonText>
}

export default ErrorMessageHandler
